import { gql } from "@apollo/client";

export const SET_NARRATIVE_SEGMENT_LOCK_STATUS = gql`
  mutation setNarrativeSegmentLockStatus(
    $input: SetNarrativeSegmentLockStatusInput!
  ) {
    setNarrativeSegmentLockStatus(input: $input) {
      clientMutationId
      errors
      locked
      narrativeSegmentUuid
    }
  }
`;
